import {
  getGridStringOperators,
  GridColDef,
  GridFilterItem,
  GridFilterOperator,
  type GridApiPremium,
} from '@mui/x-data-grid-premium'
import { RefObject } from 'react'

const containsOperator = getGridStringOperators().find(op => op.value === 'contains')

export const customNotContainsOperator: GridFilterOperator = {
  ...(containsOperator as GridFilterOperator), // forcefully cast since we know it's safe
  label: 'does not contain',
  value: 'notContains',
  getApplyFilterFn: (
    filterItem: GridFilterItem,
    column: GridColDef
  ): ((value: any, row: any, column: GridColDef, apiRef: RefObject<GridApiPremium>) => boolean) | null => {
    if (!filterItem.value) return null

    const containsFn = containsOperator?.getApplyFilterFn(filterItem, column)
    if (!containsFn) return null

    return (value, row, column, apiRef) => !containsFn(value, row, column, apiRef)
  },
}
